import {handleLogout} from "components/utils"; import React, {useEffect, useRef, useState} from 'react';
import axios from "axios";
import * as ga from "../../lib/gtag";
import {useRouter} from "next/router";
import DatePicker from "react-datepicker";
import {Form} from "react-bootstrap";

export const CustomerQueuingView = (props: { clientProfile: any, postAction: any, selectedSession: string, selectedDate: any }) => {

    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)
    const [selectedQr, setSelectedQr] = useState(null)
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [selectedEntityQr, setSelectedEntityQr] = useState(null)
    const [loading, setLoading] = useState(false)
    const [waitingPatients, setWaitingPatients] = useState()
    const [availableSessions, setAvailableSessions] = useState<Array<any>>()
    const [selectedSession, setSelectedSession] = useState<string>(null)
    const [qmeActive, setQmeActive] = useState()
    const [enableFutureDate, setEnableFutureDate] = useState()
    const [consultationFees, setConsultationFees] = useState(0.0)
    const [bookingDate, setBookingDate] = useState<Date>(new Date());
    const [uhid, setUhid] = useState<string>(null);
    const [formData, updateFormData] = useState({gender: "MALE"});
    const [name, setName] = useState<string>();
    const [options, setOptions] = useState<Array<any>>();
    const [mobile, setMobile] = useState<string>();
    const [paymentEnabled, setPaymentEnabled] = useState(false);
    const router = useRouter()
    const from = router.query["from"] && router.query["from"] != "null" ? router.query["from"].toString() : "scan"

    const [opd, setOpd] = useState<boolean>(false)

    useEffect(() => {
        // Perform localStorage action
        setOpd(localStorage.getItem('opd') == "true")
    }, [])

    useEffect(() => {
        if (uhid != null) {
            axios.get('/api/backend/customers/fetch/QME-' + uhid)
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    if (resp.data == "") {
                        updateFormData({gender: "MALE"})
                        setName(null)
                        setMobile(null)
                    } else {
                        updateFormData(resp.data)
                        setName(resp.data.name)
                        setMobile(resp.data.mobile)
                    }
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                })
        }
    }, [uhid])

    useEffect(() => {
        if (mobile != null) {
            axios.get('/api/backend/customers/fetch/all/' + mobile)
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    if (resp.data == "") {
                        setUhid(null)
                    } else if (!uhid) {
                        setOptions(resp.data)
                    }
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                })
        }
    }, [mobile])

    const handleChange = (e) => {
        setSuccess("")
        setError("")
        updateFormData({
            ...formData,
            // Trimming any whitespace
            [e.target.name]: e.target.value
        });
    };

    const handleSelectPatient = (option) => {
        setUhid(option.uhid.split("-")[1])
        setOptions([])
    };

    function addToken(uhid: any) {
        setLoading(true)
        axios.post('/api/backend/queue/qr/enqueue', {
            uhid: uhid,
            qrCode: selectedQr,
            paymentStatus: "not_paid",
            qForDate: bookingDate,
            sessionStartTime: selectedSession
        })
            .then(resp => {
                if (resp.data) {
                    // capture enqueue event
                    ga.event({
                        action: "enqueue",
                        params: {
                            uhid: uhid,
                            qrCode: selectedQr,
                            entityQrCode: selectedEntityQr,
                            paymentStatus: status,
                            by: "self",
                            from: from
                        }
                    });


                    console.log(JSON.stringify(resp.data))
                    window.location.href = window.location.origin + "/t?t=" + resp.data.id

                    setLoading(false)
                    setSuccess("* Patient queued with token no " + resp.data.token + ". Enter details for queuing new patient.")
                    if (props.postAction) {
                        props.postAction()
                    }
                } else {
                    setError("* Something went wrong. Please try again later!")
                }
            }).catch(err => {
            setError("* Something went wrong. Please try again later!")
            console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            setLoading(false)
        })
    }

    function saveCustomerData(uhid) {
        if (uhid != null) {
            axios.post('/api/backend/customer/data/save/' + uhid + '/' + selectedQr + "?qId=" +  buildQueueId(), {
                consultDate: bookingDate,
                data: JSON.stringify(new Object({data: new Object({vitals: {}})}))
            })
                .then(resp => {
                    addToken(uhid)
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
                });
        }
    }

    function initiatePayment() {
        axios.post('/api/backend/pg/initiate/upi?entityQr=' + selectedEntityQr, {
            uhid: "QME-" + uhid,
            qrCode: selectedQr,
            paymentStatus: "paid",
            qForDate: bookingDate,
            sessionStartTime: selectedSession
        })
            .then(resp => {
                if (resp.data) {
                    router.push( { pathname: "/payment", query : { order_id: resp.data }})
                } else {
                    setError("* Something went wrong. Please try again later!")
                }
            }).catch(err => {
            setError("* Something went wrong. Please try again later!")
            console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            setLoading(false)
        })
    }

    function save() {
        setLoading(true)
        if (uhid == null || uhid == "") {
            axios.post('/api/backend/customers/create', {
                ...formData,
                name: name,
                mobile: mobile,
            })
                .then(resp => {
                    if(paymentEnabled) {
                        initiatePayment()
                    } else {
                        saveCustomerData("QME-" + uhid)
                    }
                })
                .catch(err => {
                    setError("* Something went wrong! Please try again in some time.")
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
                });
        } else {
            if(paymentEnabled) {
                initiatePayment()
            } else {
                saveCustomerData("QME-" + uhid)
            }
        }
    }

    function buildQueueId() {
        var ISTTime = new Date(bookingDate);
        return selectedQr + "_" + ISTTime.toISOString().slice(0, 10) + "_" + selectedSession
    }

    useEffect(() => {
        if (selectedQr) {
            axios.get('/api/backend/client/config/fetch/' + selectedQr)
                .then(resp => {
                    if (resp.data) {
                        setQmeActive(resp.data.qmeActive)
                        setEnableFutureDate(resp.data.futureAppointments)
                        setConsultationFees(resp.data.consultationFee)
                        setPaymentEnabled(resp.data.collectPayment)
                    }
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                })
            if (bookingDate) {
                axios.get('/api/backend/sessions/client/' + selectedQr + "?bookingDate=" + bookingDate.toISOString())
                    .then(resp => {
                        console.log(JSON.stringify(resp.data))
                        if ((!resp.data || resp.data.length == 0) && props.selectedSession != null) {
                            //push emergency session in available session if it's coming from the parent component.
                            setAvailableSessions([{startTime: selectedSession, displayText: "Emergency Session"}])
                        } else {
                            setAvailableSessions(resp.data)
                        }
                        if (props.selectedSession) {
                            setSelectedSession(props.selectedSession)
                        } else {
                            setSelectedSession(resp.data[0].startTime)
                        }
                    })
                    .catch(err => {
                        console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                    })
            }
        }
    }, [selectedQr])

    useEffect(() => {
        if (bookingDate && selectedQr) {
            axios.get('/api/backend/sessions/client/' + selectedQr + "?bookingDate=" + bookingDate.toISOString())
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    setAvailableSessions(resp.data)
                    setSelectedSession(resp.data[0].startTime)
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                })
        }
    }, [bookingDate])

    useEffect(() => {
        if (selectedSession) {
            axios.get('/api/backend/user/client/profile?qrCode=' + selectedQr + "&qId=" + selectedQr + "_" + bookingDate.toISOString().slice(0, 10) + "_" + selectedSession)
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    setWaitingPatients(resp.data.waitingPatients)
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                })
                .finally(() => {
                    setLoading(false)
                })
        }
    }, [selectedSession])

    useEffect(() => {
        if (props.clientProfile) {
            setSelectedQr(props.clientProfile["qrCode"])
            setSelectedEntityQr(props.clientProfile["entityQrCode"])
            setSelectedCategory(props.clientProfile["category"])
        }
        if (props.selectedDate) {
            setBookingDate(props.selectedDate)
        }

    }, [props.clientProfile, props.selectedDate])

    function getPetFormData() {
        return <>
            <div className="row">

                <div className="col col-12 col-lg-12">
                    <Form.Group className="mb-3" controlId="formUhid">
                        <Form.Label className="fs-7 text-secondary">UHID</Form.Label>
                        <div className="d-flex gap-2">
                            <span className="fs-7 text-nowrap align-self-center">Qme -</span>
                            <Form.Control value={uhid ? uhid : ""} onChange={e => setUhid(e.target.value)}
                                          name="uhid"
                                          type="text" size={"sm"}
                                          placeholder="Enter UHID if Available"/>
                        </div>
                    </Form.Group>
                </div>
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formPhone">
                        <Form.Label className="fs-7 text-secondary">Phone no.<span
                            className="text-danger">*</span></Form.Label>
                        <Form.Control value={mobile ? mobile : ""} onChange={e => setMobile(e.target.value)}
                                      name="mobile" type="text" size={"sm"}
                                      placeholder="Enter Phone Number"/>
                    </Form.Group>
                </div>
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formName">
                        <Form.Label className="fs-7 text-secondary">Pet Name<span
                            className="text-danger">*</span></Form.Label>
                        <Form.Control value={name ? name : ""} onChange={e => setName(e.target.value)} name="name"
                                      type="text" size={"sm"}
                                      placeholder="Enter Pet Name"/>
                    </Form.Group>
                    {options && options.length > 0 &&
                        <div className="mb-3">
                            {options.map((o) => {
                                return <Form.Check
                                    key={o}
                                    label={o.name}
                                    name="options"
                                    type={"radio"}
                                    checked={name == o}
                                    onChange={() => handleSelectPatient(o)}
                                />
                            })}
                        </div>
                    }
                </div>
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formFather">
                        <Form.Label className="fs-7 text-secondary">Owner&apos;s name<span
                            className="text-danger">*</span></Form.Label>
                        <Form.Control value={formData['fatherName'] ? formData['fatherName'] : ""}
                                      onChange={handleChange} name="fatherName" type="text" size={"sm"}
                                      placeholder="Enter Owner's name"/>
                    </Form.Group>
                </div>

                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formPetAge">
                        <Form.Label className="fs-7 text-secondary">Pet Age</Form.Label>
                        <Form.Control value={formData['age'] ? formData['age'] : ""} onChange={handleChange} name="age"
                                      type="text" size={"sm"}
                                      placeholder="Enter pet age"/>
                    </Form.Group>
                </div>

                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formPetGender">
                        <Form.Label className="fs-7 text-secondary">Pet Gender</Form.Label>
                        <Form.Control value={formData['gender'] ? formData['gender'] : ""} onChange={handleChange}
                                      name="gender" type="text" size={"sm"}
                                      placeholder="Enter pet gender"/>
                    </Form.Group>
                </div>
            </div>
        </>;
    }


    function getPatientFormData() {
        return <>
            <div className="row">
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formUhid">
                        <Form.Label className="fs-7 text-secondary">UHID</Form.Label>
                        <div className="d-flex gap-2">
                            <span className="fs-7 text-nowrap align-self-center">QMe -</span>
                            <Form.Control value={uhid ? uhid : ""} onChange={e => setUhid(e.target.value)}
                                          name="uhid" type="text" size={"sm"}
                                          placeholder="Enter UHID if Available"/>
                        </div>
                    </Form.Group>
                </div>
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formPhone">
                        <Form.Label className="fs-7 text-secondary">Phone no.<span
                            className="text-danger">*</span></Form.Label>
                        <Form.Control value={mobile ? mobile : ""} onChange={e => setMobile(e.target.value)}
                                      name="mobile" type="text" size={"sm"}
                                      placeholder="Enter Phone Number"/>
                    </Form.Group>
                </div>
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formName">
                        <Form.Label className="fs-7 text-secondary">Name<span
                            className="text-danger">*</span></Form.Label>
                        <Form.Control value={name ? name : ""} onChange={e => setName(e.target.value)} name="name"
                                      type="text" size={"sm"}
                                      placeholder="Enter Name"/>
                    </Form.Group>
                    {options && options.length > 0 &&
                        <div className="mb-3">
                            {options.map((o) => {
                                return <Form.Check
                                    key={o}
                                    label={o.name}
                                    name="options"
                                    type={"radio"}
                                    checked={name == o}
                                    onChange={() => handleSelectPatient(o)}
                                />
                            })}
                        </div>
                    }
                </div>
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formAge">
                        <Form.Label className="fs-7 text-secondary">Age</Form.Label>
                        <Form.Control value={formData['age'] ? formData['age'] : ""} onChange={handleChange} name="age"
                                      type="tel" size={"sm"}
                                      placeholder="Enter age in years"/>
                    </Form.Group>
                </div>

                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formGender">
                        <Form.Label className="fs-7 text-secondary">Gender</Form.Label>
                        <Form.Select onChange={handleChange} value={formData['gender']} name="gender" size={"sm"}>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Transgender">Transgender</option>
                            <option value="Other">Other</option>
                        </Form.Select>
                    </Form.Group>
                </div>
            </div>
        </>;
    }

    function getCustomerDetails() {
        return <>

            <div className="">

                {!qmeActive &&
                    <div className="my-2 font-weight-bold text-danger">The doctor is not taking online appointments
                        right now. Please try later.</div>
                }

                {consultationFees > 0 && <div className="my-3"><b>Consultation Fee:</b> ₹ {consultationFees}</div>}

                {opd && enableFutureDate && <div className="d-flex gap-2 pt-3">
                    <label className="text-secondary text-nowrap align-self-center">Appointment Date:</label>
                    <DatePicker className="form-control" selected={bookingDate}
                                onChange={(date: Date) => setBookingDate(date)} dateFormat="dd/MM/yyyy"
                                minDate={new Date()}
                                disabled={props.selectedDate}
                    />
                </div>}

                {availableSessions && availableSessions.length > 1 &&
                    <div className="d-flex gap-2 pt-3">
                        <label className="text-secondary text-nowrap align-self-center">Timings:</label>
                        <select className="form-select"
                                value={selectedSession}
                                onChange={e => setSelectedSession(e.target.value)}
                        >
                            {availableSessions.map(session => {
                                return <option value={session.startTime}
                                               key={session.startTime}>
                                    {session.displayText && <>{session.displayText}</>}
                                    {!session.displayText && <>{session.startTimeText} - {session.endTimeText}</>}
                                </option>
                            })}
                        </select>
                    </div>
                }

                {selectedSession && <div className="my-3">
                    <div className="text-muted fs-5 d-inline-block"> Patients Already In Queue:&nbsp;&nbsp;</div>
                    <div className="font-weight-bold fs-4 d-inline-block">{waitingPatients}</div>
                </div>}

                {selectedCategory == "Veterinarian" && getPetFormData()}
                {selectedCategory != "Veterinarian" && getPatientFormData()}

                <div className="my-3">
                    <button className="form-control btn btn-info text-white"
                            disabled={!qmeActive || !selectedSession}
                            onClick={save}>
                        <div className="text-white">Save</div>
                    </button>
                </div>
                {/*{!props.needsRedirection &&
                    <div className="mt-3">
                        <button className="form-control btn btn-secondary text-white"
                                onClick={handlePlaceholder}> Add placeholder
                        </button>
                    </div>
                }*/}
            </div>
            {error &&
                <div className="my-3 text-danger fs-6">{error}</div>
            }
            {success &&
                <div className="my-3 text-success fs-6">{success}</div>
            }

        </>;
    }

    return (
        <>
            {!loading &&
                <div className="col-12">
                    {getCustomerDetails()}
                </div>
            }
            {loading &&
                <div className="text-center py-5">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            }
        </>
    );
};

